import {
  ADD_AGENT_STARTED,
  ADD_AGENT_COMPLETED,
  ADD_AGENT_ERROR,
  FETCH_AGENTS_STARTED,
  FETCH_AGENTS_COMPLETED,
  FETCH_AGENTS_ERROR,
  EDIT_AGENT_STARTED,
  EDIT_AGENT_COMPLETED,
  EDIT_AGENT_ERROR,
  DELETE_AGENT_STARTED,
  DELETE_AGENT_COMPLETED,
  DELETE_AGENT_ERROR
} from '../actionTypes/agentActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  agents: {}
};

function agentReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_AGENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_AGENT_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.agents[key] = data;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_AGENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_AGENTS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_AGENTS_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          agents: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_AGENTS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case EDIT_AGENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case EDIT_AGENT_COMPLETED: {
      let key = action.payLoad.id;
      let data = action.payLoad.data;
      state.agents[key] = data;
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case EDIT_AGENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case DELETE_AGENT_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case DELETE_AGENT_COMPLETED: {
      let result = {};
      Object.keys(state.agents).filter((key) => {
        if (key !== action.payLoad) {
          result[key] = state.agents[key];
        }
      });
      return {
        ...state,
        agents: { ...result },
        submitted: false,
        success: true
      };
    }
    case DELETE_AGENT_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default agentReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/agentReducer.js